document.addEventListener('DOMContentLoaded', function(){

    const nuevoIconoHTML = `
    <div class="t4s-site-nav__icon t4s-site-nav__custom custom-icon-dropdown">
        <a href="/nueva-pagina" class="t4s-pr" aria-label="Nueva sección">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" style="height:22px; width:22px;" viewBox="0 0 24 24" stroke-width="1.5" stroke="black" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418" />
            </svg>
        </a>
        <div class="custom-dropdown-menu">
        <ul>
            <li><a href="/opcion-1">Colombia Store</a></li>
            <li><a href="/opcion-2">USA Store</a></li>
        </ul>
        </div>
    </div>
    `;

    const googleTranslate = document.getElementById("google_translate_element2");
    if (googleTranslate) {
      const wrapper = document.createElement("div");
      wrapper.innerHTML = nuevoIconoHTML;
      googleTranslate.parentNode.insertBefore(wrapper.firstElementChild, googleTranslate);
    }
    
    /* -------- Colocar redireccion mobile --------
    const redireccionMobileLink = document.getElementById("redireccion-usa-mobile");
    if (redireccionMobileLink) {
    const iconoSoloMobile = document.createElement("span");
    iconoSoloMobile.className = "icono-mobile-only";
    iconoSoloMobile.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" style="height:18px; width:18px; vertical-align:middle; margin-right:6px;" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418" />
        </svg>
    `;
    redireccionMobileLink.insertBefore(iconoSoloMobile, redireccionMobileLink.firstChild);
    }
    */

    const hrefColombia = "https://www.youaresavvy.com/";
    const textColombia = "Buy at Savvy Colombia";

    /*
    const hrefChile = "https://www.ketoclub.cl/collections/savvy?utm_source=savvy&utm_medium=web+colombia&utm_campaign=footer";
    const textChile = "Compra Savvy en Chile";
    */

    const allLinks = document.querySelectorAll('a.t4s-footer-link');

    let currentLinkToRedirect = null;

    //----------Pop Up para redireccion a USA----------
    const popupOverlayUSA = document.createElement('div');
    popupOverlayUSA.className = 'custom-popup-overlay';

    const popupContentUSA = document.createElement('div');
    popupContentUSA.className = 'custom-popup-content';

    const popUpHeaderUSA = document.createElement('h2');
    popUpHeaderUSA.textContent = "Redirecting to Savvy Colombia";

    const popupMessageUSA = document.createElement('p');
    popupMessageUSA.textContent = "You are about to go to our store in Colombia. Do you want to continue?";

    const popupButtonsUSA = document.createElement('div');
    popupButtonsUSA.className = 'custom-popup-buttons';

    const acceptButtonUSA = document.createElement('button');
    acceptButtonUSA.textContent = 'Accept';
    acceptButtonUSA.className = 'accept-btn';

    const cancelButtonUSA = document.createElement('button');
    cancelButtonUSA.textContent = 'Cancel';
    cancelButtonUSA.className = 'cancel-btn';

    popupButtonsUSA.appendChild(acceptButtonUSA);
    popupButtonsUSA.appendChild(cancelButtonUSA);
    popupContentUSA.appendChild(popUpHeaderUSA);
    popupContentUSA.appendChild(popupMessageUSA);
    popupContentUSA.appendChild(popupButtonsUSA);
    popupOverlayUSA.appendChild(popupContentUSA);
    document.body.appendChild(popupOverlayUSA);

    function showPopupUSA() {
        popupOverlayUSA.style.display = 'flex';
    }

    function hidePopupUSA() {
        popupOverlayUSA.style.display = 'none';
    }

    acceptButtonUSA.addEventListener('click', function() {
        if (currentLinkToRedirect) {
            window.location.href = currentLinkToRedirect;
        }
        hidePopupUSA();
    });

    cancelButtonUSA.addEventListener('click', function() {
        hidePopupUSA();
    });

    //----------Pop Up para redireccion a Chile----------
    /*
    const popupOverlayChile = document.createElement('div');
    popupOverlayChile.className = 'custom-popup-overlay';

    const popupContentChile = document.createElement('div');
    popupContentChile.className = 'custom-popup-content';

    const popUpHeaderChile = document.createElement('h2');
    popUpHeaderChile.textContent = "Redirigiéndote a Keto Club Chile";

    const popupMessageChile = document.createElement('p');
    popupMessageChile.textContent = "Estás a punto de dirigirte a nuestro distribuidor en Chile. ¿Deseas continuar?";

    const popupButtonsChile = document.createElement('div');
    popupButtonsChile.className = 'custom-popup-buttons';

    const acceptButtonChile = document.createElement('button');
    acceptButtonChile.textContent = 'Aceptar';
    acceptButtonChile.className = 'accept-btn';

    const cancelButtonChile = document.createElement('button');
    cancelButtonChile.textContent = 'Cancelar';
    cancelButtonChile.className = 'cancel-btn';

    popupButtonsChile.appendChild(acceptButtonChile);
    popupButtonsChile.appendChild(cancelButtonChile);
    popupContentChile.appendChild(popUpHeaderChile);
    popupContentChile.appendChild(popupMessageChile);
    popupContentChile.appendChild(popupButtonsChile);
    popupOverlayChile.appendChild(popupContentChile);
    document.body.appendChild(popupOverlayChile);

    function showPopupChile() {
        popupOverlayChile.style.display = 'flex';
    }

    function hidePopupChile() {
        popupOverlayChile.style.display = 'none';
    }

    acceptButtonChile.addEventListener('click', function() {
        if (currentLinkToRedirect) {
            window.location.href = currentLinkToRedirect;
        }
        hidePopupChile();
    });

    cancelButtonChile.addEventListener('click', function() {
        hidePopupChile();
    });
    */

    for(const link of allLinks){
        if(link.href === hrefColombia || link.textContent.trim() === textColombia){
            link.addEventListener('click', function(event){
                event.preventDefault();
                currentLinkToRedirect = link.href;
                showPopupUSA();
            });
        }

        /*
        if(link.href === hrefChile || link.textContent.trim() === textChile){
            link.addEventListener('click', function(event){
                event.preventDefault();
                currentLinkToRedirect = link.href;
                showPopupChile();
            });
        }
        */
    }
    const opcion1Link = document.querySelector('a[href="/opcion-1"]');
    if (opcion1Link) {
        opcion1Link.addEventListener('click', function(event) {
            event.preventDefault();
            currentLinkToRedirect = hrefColombia;
            showPopupUSA();
        });
    }
    const opcion2Link = document.querySelector('a[href="/opcion-2"]');
    if (opcion2Link) {
        opcion2Link.addEventListener('click', function(event) {
            event.preventDefault();
            window.location.href = "https://us.youaresavvy.com/";
        });
    }
    const iconDropdown = document.querySelector('.custom-icon-dropdown');
    const dropdownMenu = iconDropdown?.querySelector('.custom-dropdown-menu');
    const iconAnchor = iconDropdown?.querySelector('a');

    if (iconAnchor && dropdownMenu) {
        iconAnchor.addEventListener('click', function(event) {
            event.preventDefault();
            dropdownMenu.style.display = dropdownMenu.style.display === 'block' ? 'none' : 'block';
        });

        // Opcional: cerrar el menú al hacer clic fuera
        document.addEventListener('click', function(event) {
            if (!iconDropdown.contains(event.target)) {
                dropdownMenu.style.display = 'none';
            }
        });
    }

});
